/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import SideNav from "./SideNav";
import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { ROUTES } from "constants/routes";
import RequirePermission from "components/AppRouter/RequirePermission";
import UseProfileModel from "models/main/useProfileModel";
import TwoFactorSetupBanner from "./TwoFactorSetupBanner";

const DashboardLayout = () => {
  const location = useLocation();
  
  const [isOpen, setIsOpen] = useState<boolean>(true);

  UseProfileModel();

  const currentPage = location.pathname.split("/")[2];
  const subRoute = location.pathname.split("/")[3];

  return (
    <>
      <Flex flexDirection="row">
        <SideNav 
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
        <Box
          height={{ base: "calc(100% - 64px)", lg: "100vh" }}
          overflowY="auto"
          pb="30px"
          width={"100%"}
          bgColor="gray.50"
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={6}
            backgroundColor={"gray.50"}
            px={[10, 10, 14]}
            py={10}
            ml={isOpen ? '220px' : "80px"}
            width={isOpen ? "calc(100% - 220px)": "calc(100% - 80px)" }
            borderRadius={"15px"}
            shadow="none"
          >
            <Breadcrumb separator={<ChevronRightIcon color="gray.200" />}>
              <BreadcrumbItem>
                <BreadcrumbLink
                  href={ROUTES.DASHBOARD.path}
                  fontSize={14}
                  color="#595959"
                >
                  Home
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink
                  href={subRoute ? `${ROUTES.MAIN.path}/${currentPage}` : "#"}
                  textTransform="capitalize"
                  fontSize={14}
                  color="#595959"
                >
                  {currentPage === "dashboard" ? "" : currentPage}
                </BreadcrumbLink>
              </BreadcrumbItem>
              {subRoute ? (
                <BreadcrumbItem>
                  <BreadcrumbLink
                    href="#"
                    textTransform="capitalize"
                    fontSize={14}
                    color="#595959"
                  >
                    {subRoute}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              ) : null}
            </Breadcrumb>
            <TwoFactorSetupBanner />
            <RequirePermission>
              <Outlet />
            </RequirePermission>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default DashboardLayout;
